<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
      <h2 class="text-xl font-semibold text-gray-800 mb-4">Generar certificado de regalo</h2>

      <div class="space-y-3">
        <div>
          <label class="block text-sm text-gray-700">Nombre del destinatario</label>
          <input v-model="destinatarioNombre" type="text" class="input-field" placeholder="Ej. Ana Rivera" />
        </div>

        <div>
          <label class="block text-sm text-gray-700">Correo del destinatario</label>
          <input v-model="destinatarioEmail" type="email" class="input-field" placeholder="Ej. ana@email.com" />
        </div>

        <div>
          <label class="block text-sm text-gray-700">Monto del certificado</label>
          <input v-model.number="monto" type="number" min="1" class="input-field" placeholder="Ej. 100" />
        </div>

        <div>
          <label class="block text-sm text-gray-700">Mensaje opcional</label>
          <textarea v-model="mensaje" rows="2" class="input-field" placeholder="¡Disfrútalo!"></textarea>
        </div>
      </div>

      <div class="mt-6 flex justify-end space-x-3">
        <button @click="close" class="btn-secondary">Cancelar</button>
        <button @click="generarCertificado" class="btn-primary">Generar</button>
      </div>

      <button @click="close" class="absolute top-3 right-3 text-gray-400 hover:text-gray-600">
        ✕
      </button>
    </div>
  </div>
</template>


<script setup>
/* eslint-disable no-undef */
import { ref, watch } from "vue";
import { nanoid } from "nanoid" 


const props = defineProps({
  isOpen: Boolean,
  
  datosIniciales: Object,
})

const emit = defineEmits(["close", "certificadoCreado"])

const destinatarioNombre = ref("")
const destinatarioEmail = ref("")
const monto = ref(0)
const mensaje = ref("")
const remitenteNombre = ref("")
// eslint-disable-next-line no-unused-vars
const isSending = ref(false)

function close() {
  emit("close")
}
function resetCampos() {
  destinatarioNombre.value = "";
  destinatarioEmail.value = "";
  monto.value = 0;
  mensaje.value = "";
  remitenteNombre.value = "";
}
function generarCertificado() {
  if (!destinatarioNombre.value || !destinatarioEmail.value || monto.value <= 0) {
    alert("Todos los campos obligatorios deben estar completos.");
    return;
  }

  // ✅ Generar ID único correcto
  const uuid = nanoid();

  emit("certificadoCreado", {
    destinatarioNombre: destinatarioNombre.value,
    destinatarioEmail: destinatarioEmail.value,
    mensaje: mensaje.value,
    monto: monto.value,
    remitenteNombre: remitenteNombre.value,
    uuid,   // ✅ ahora sí existe
    id: uuid // opcional, pero consistente con tu backend
  });

  resetCampos();
  close();
}


watch(
  () => props.isOpen,
  (abierto) => {
    if (abierto && props.datosIniciales) {
      monto.value = props.datosIniciales.monto || 0;
      mensaje.value = props.datosIniciales.mensaje || "";
      remitenteNombre.value = props.datosIniciales.remitente || "";
    }
  }
);
</script>

<style scoped>
.input-field {
  @apply w-full border border-gray-300 rounded px-3 py-2 mt-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500;
}
.btn-primary {
  @apply bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50;
}
.btn-secondary {
  @apply bg-gray-100 text-gray-800 px-4 py-2 rounded hover:bg-gray-200;
}
</style>
